import { baseApi } from "../../../api/baseApi.js";
import { prepareQueryParams, toFormData } from "../../../helpers/index.js";

const baseUrl = "/paypal/order";

export const paypalApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createPayPalOrder: build.mutation({
      query: ({ orderId, ...payload }) => {
        return {
          url: `${baseUrl}/${orderId}`,
          method: "POST",
          body: toFormData({ ...payload, ...prepareQueryParams() }),
        };
      },
    }),
    capturePayPalPayment: build.mutation({
      query: (paypalOrderId) => ({
        url: `${baseUrl}/${paypalOrderId}/capture`,
        method: "POST",
      }),
    }),
  }),
});

export const { useCapturePayPalPaymentMutation, useCreatePayPalOrderMutation } =
  paypalApi;
